import { gql } from '@apollo/client';

export const SEND_NOTIFICATION = gql`
  mutation sendNotification($id: ID!, $body: String) {
    sendNotification(id: $id, body: $body)
      @rest(
        type: "SendPushNotification"
        path: "/v2/api/push/notification"
        method: "POST"
        endpoint: "bff"
        bodyKey: "body"
      ) {
      id
    }
  }
`;
